export default __webpack_public_path__ + "static/media/Legguards of the Tormentor.e6fcbb59.jpg";